import { useEffect } from 'react';
import { useTitle } from 'react-use';

import { Layout } from 'CorePackage/MainModule/components/Layout';

import { SystemInoperabilityContainer } from './SystemInoperabilityContainer';
import styles from './News.module.scss';

export const SystemInoperability = () => {
  useTitle('Периоды неработоспособности системы');
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  return (
    <>
      <Layout>
        <div className={styles.NewsPage}>
          <SystemInoperabilityContainer />
        </div>
      </Layout>
    </>
  );
};
